import React from "react";

import { UniformContext } from "@uniformdev/context-react";

import ContentNotFoundErrorBoundary from "@/content/utils/content-not-found-error-boundary";
import { FourOhFourPageTemplate } from "@/templates/404/404-page/src/404-page.template";

import { UniformPreviewPageProps } from "../../../../pages/uniform-preview/uniform-preview-page";
import { UniformWrapper } from "../../../../uniform/uniform-wrapper";
import { useWAEContext } from "../../../../uniform/utils/wae-context-provider";

export const UniformPreviewPageTemplate: React.FC<UniformPreviewPageProps> = ({
    composition,
    isUniformPlayground,
    isAllowPostMessage
}) => {
    const { uniformContext } = useWAEContext();

    return (
        <ContentNotFoundErrorBoundary fallback={<FourOhFourPageTemplate />}>
            <UniformContext context={uniformContext}>
                <UniformWrapper
                    composition={composition}
                    isUniformPlayground={isUniformPlayground}
                    isAllowPostMessage={isAllowPostMessage}
                />
            </UniformContext>
        </ContentNotFoundErrorBoundary>
    );
};
